import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CloseState } from '../../../../../interface';

export interface CloseOpportunityData {
  disableCloseOppNotes: boolean;
  closeState?: CloseState;
}

@Component({
  selector: 'sales-ui-close-opportunity-dialog',
  templateUrl: './close-opportunity-dialog.component.html',
  styleUrls: ['./close-opportunity-dialog.component.scss'],
  standalone: false,
})
export class CloseOpportunityDialogComponent implements OnInit {
  closeOpportunityForm: UntypedFormGroup;
  closeState = CloseState;

  constructor(
    private readonly fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CloseOpportunityDialogComponent>,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) private readonly data: CloseOpportunityData, // Need to provide close-lost reasons // @Inject(ACCESS_TO_ZENDESK_CLOSED_LOST_REASONS) readonly hasAccessToZendeskClosedLostReasons$: Observable<boolean>,
  ) {}

  // zendeskClosedLostReasonGroups = zendeskClosedLostReasonGroups;

  closeStateOptions = [
    { value: '', displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.SELECT_STATE') },
    { value: CloseState.WON, displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSED_WON') },
    {
      value: CloseState.LOST,
      displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSED_LOST'),
    },
  ];

  defaultReason = {
    value: '',
    displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.SELECT_REASON'),
  };

  reasonOptions = [
    {
      value: 'price',
      displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.PRICE'),
    },
    {
      value: 'no-budget',
      displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.NO_BUDGET'),
    },
    {
      value: 'lost-to-competitor',
      displayValue: this.translate.instant(
        'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.LOST_TO_COMPETITOR',
      ),
    },
    {
      value: 'not-ready',
      displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.NOT_READY'),
    },
    {
      value: 'other',
      displayValue: this.translate.instant('FRONTEND.SALES_UI.SALES_OPPORTUNITIES.CLOSE.CLOSED_LOST.OTHER'),
    },
  ];

  ngOnInit(): void {
    this.createForm();
  }

  isCloseStateNullOrUndefined(): boolean {
    return this.data ? this.data.closeState === null || this.data.closeState === undefined : true;
  }

  createForm(): void {
    this.closeOpportunityForm = this.fb.group({
      closeState: [this.getInitialCloseState(), Validators.required],
      reason: '',
      notes: '',
      actualClosedDate: new Date(),
    });
    if (this.data && this.data.disableCloseOppNotes) {
      this.closeOpportunityForm.get('notes').disable();
    }

    if (this.data?.closeState) {
      this.closeOpportunityForm.controls.closeState.setValue(this.data.closeState);
      this.updateCloseOpportunityReason(this.closeOpportunityForm);
    } else {
      this.closeOpportunityForm.get('closeState').valueChanges.subscribe(() => {
        this.updateCloseOpportunityReason(this.closeOpportunityForm);
      });
    }
  }

  private getInitialCloseState(): CloseState {
    return this.isCloseStateNullOrUndefined() ? CloseState.WON : this.data.closeState;
  }

  private updateCloseOpportunityReason(closeOpportunityForm: UntypedFormGroup): void {
    const reason = closeOpportunityForm.get('reason');
    if (this.data.closeState === CloseState.LOST) {
      reason.setValidators(Validators.required);
    } else {
      reason.setValidators([]);
      reason.setValue('');
    }
    reason.updateValueAndValidity();
  }
}
